import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import 'moment-timezone';
import AuthContext from "context/AuthContext";
import { useContext } from "react";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const PrevDatesUser = (props) => {
    const { t: tC } = useCustomTranslation(translations);

    return (
        <div className={`col preview-row ${props.showPreview ? "" : "d-none"}`}
            style={{ width: "300px", maxWidth: "300px" }}>
            <div className="row">
                <div className="col-12 p-0">
                    <div className="preview-card" style={{ width: "300px" }}>
                        <div className="preview-header">
                            <div className="preview-icon">
                                <FontAwesomeIcon icon="users" />
                            </div>
                            <div className="preview-title">
                                <label>{tC("user.email")}</label>
                                <div>{props.item.email}</div>
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tC("user.created")}</label>
                            <div className="preview-input">
                                {props.item.date_joined ? moment(props.item.date_joined).format("DD-MM-YYYY hh:mm") : "-"}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tC("user.updated")}</label>
                            <div className="preview-input">
                                {props.item.updated_at ? moment(props.item.updated_at).format("DD-MM-YYYY hh:mm") : "-"}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tC("user.lastLogin")}</label>
                            <div className="preview-input">
                                {props.item.last_login ? moment(props.item.last_login).format("DD-MM-YYYY hh:mm") : "-"}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tC("user.confirmed")}</label>
                            <div className="preview-input">
                                {props.item.confirmed_at ? moment(props.item.confirmed_at).format("DD-MM-YYYY hh:mm") : "-"}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tC("user.passwordChanged")}</label>
                            <div className="preview-input">
                                {props.item.last_change_pass ? moment(props.item.last_change_pass).format("DD-MM-YYYY hh:mm") : "-"}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tC("user.lastChangeRequest")}</label>
                            <div className="preview-input">
                                {props.item.reset_password_to_at ? moment(props.item.reset_password_to_at).format("DD-MM-YYYY hh:mm") : "-"}
                            </div>
                        </div>
                        <div className="preview-item">
                            <label>{tC("user.blocked")}</label>
                            <div className="preview-input">
                                {props.item.blocked_at ? moment(props.item.blocked_at).format("DD-MM-YYYY hh:mm") : "-"}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PrevDatesUser;